import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { IPackageItem } from "../../api";
import { PackageItemsList } from "components/PackageItemsList";
import { StatusMessage } from "components/StatusMessage";
import { ViewDetails } from "components/ViewDetails";

import "./index.css";

interface Props {
  item: IPackage;
  packageItems: (IPackageItem & { accepted: boolean, rejected: boolean, accepting: boolean, rejecting: boolean })[];
  onAcceptItem: (item: IPackageItem, price: number) => any;
  onRejectItem: (item: IPackageItem) => any;
  onItemPriceChanged: (item: IPackageItem, price: number) => any;
}

export function UnderReview({
  item,
  packageItems,
  onAcceptItem,
  onRejectItem,
  onItemPriceChanged
}: Props) {
  return (
    <div>
      <StatusMessage
        message="We are currently reviewing your items"
        actionType="admin"
      />
      <div className="col-12">
        <p>
          We are currently reviewing your package. Please note that items can be
          conditionally accepted and you will need to bear the cost of any
          laundry or mending services we decide to use to make the product more
          attractive to potential buyers.
        </p>
      </div>
      <div className="mb-4">
        <PackageItemsList
          packageItems={packageItems}
          onAcceptItem={onAcceptItem}
          onRejectItem={onRejectItem}
          onItemPriceChanged={onItemPriceChanged}
        />
      </div>
      <hr/>
      <ViewDetails item={item} />
    </div>
  );
}
